import React, { useContext } from "react"
import { Row, Col, Badge } from "reactstrap"
import ScaleText from "react-scale-text"
import EllipsisText from "react-ellipsis-text"
import moment from "moment"
import PropTypes from "prop-types"
import { TEXT, PHOTO, FILE } from "../messageTypes"
import MessageContext from "../MessageContext"
import "../style.css"
// import customerImage from "../../../assets/images/avatar/avatar-customer.png"

const ChatRoom = ({ client, assistantUnreadCount, lastMessage, id }) => {
  const { chatRoomId, setChatUser, setChatRoomId, setIsInitChat } = useContext(
    MessageContext
  )

  const username = (
    <div className="font-medium no-scrollbar">
      <ScaleText widthOnly={true} maxFontSize={14}>
        {client?.name}
      </ScaleText>
    </div>
  )

  const msgText = (lastMessage, client) => {
    if (!lastMessage) {
      return null
    }

    switch (lastMessage.type) {
      case TEXT:
        return (
          <div className="text-muted no-scrollbar">
            <ScaleText widthOnly={true} maxFontSize={14}>
              <EllipsisText text={lastMessage.content || ""} length={35} />
            </ScaleText>
          </div>
        )
      case PHOTO:
        return (
          <div className="text-muted no-scrollbar">
            <ScaleText widthOnly={true} maxFontSize={14}>
              <EllipsisText
                text={
                  lastMessage.sender.id === client.id
                    ? `${client.name}向您傳送了圖片`
                    : "圖片已傳送"
                }
                length={25}
              />
            </ScaleText>
          </div>
        )
      case FILE:
        return (
          <div className="text-muted no-scrollbar">
            <ScaleText widthOnly={true} maxFontSize={14}>
              <EllipsisText
                text={
                  lastMessage.sender.id === client.id
                    ? `${client.name}向您傳送了檔案`
                    : "檔案已傳送"
                }
                length={25}
              />
            </ScaleText>
          </div>
        )
      default:
        return null
    }
  }

  const msgTime = (lastMessage) => {
    if (!lastMessage) {
      return null
    }

    const displayTime = (dateTime) => {
      if (moment().diff(dateTime, "days") < 1) {
        return moment(dateTime).format("a h:mm")
      }

      return moment(dateTime).format("YYYY-MM-DD")
    }

    return (
      <h6 className="text-muted no-scrollbar">
        <ScaleText widthOnly={true} maxFontSize={12}>
          {displayTime(lastMessage.createdAt)}
        </ScaleText>
      </h6>
    )
  }

  const unReads =
    assistantUnreadCount > 0 ? (
      <Badge color="danger" pill>
        {assistantUnreadCount}
      </Badge>
    ) : null

  return (
    <div
      id={client?.id}
      className="unselectable pointer"
      onClick={() => {
        if (chatRoomId !== id) {
          setChatUser(client?.name)
          setChatRoomId(id)
          setIsInitChat(true)
        }
      }}
    >
      <Row>
        <Col sm={7}>
          <div className="ml-2 mr-2">
            {username}{" "}
            <div className="mt-0" style={{ fontSize: "10px" }}>
              {client?.company?.name}
            </div>
          </div>
        </Col>
        <Col sm={5}>
          {msgTime(lastMessage)}
          {unReads}
        </Col>
        <Col className="ml-2 mr-2" sm={12}>
          {msgText(lastMessage, client)}
        </Col>
      </Row>
    </div>
  )
}

ChatRoom.propTypes = {
  client: PropTypes.object.isRequired,
  assistantUnreadCount: PropTypes.number.isRequired,
  lastMessage: PropTypes.object,
  id: PropTypes.string.isRequired
}

export default ChatRoom
